// removed by extract-text-webpack-plugin
module.exports = {"projectInfoWindow":"_1xfl73WCtdAfKbrUVqxwXk","imageSection":"_3uwi-pdUQjsWPAfMclAt6S","image":"_2fDDl_G39vij46Txh-1bbi","price":"_11ksC0iMcmyRC_SutPX77b","descriptionSection":"_Z045m8ZduWG8K76kxlWZ","name":"_3M4d-4aERisNLW3jZCjx1V","status":"NkpOKI-N7wYVitM1zSdW1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectInfoWindow/ProjectInfoWindow.scss
// module id = 1709
// module chunks = 0